<script lang="ts">
  import FloatingLabel from '#lib/components/FloatingLabel.svelte';

  interface Props {
    title: string;
    name: string;
    manyItems?: boolean;
    disabled?: boolean;
    value: boolean | undefined;
  }

  let { title, name, manyItems, disabled, value = $bindable() }: Props = $props();
</script>

<FloatingLabel {title}>
  {#snippet input()}
    {#if manyItems}
      <select class="select" {disabled} bind:value>
        <option value={undefined}>Unchanged</option>
        <option value={true}>True</option>
        <option value={false}>False</option>
      </select>
    {:else}
      <label class="input !outline-0">
        <input
          type="checkbox"
          {name}
          class="checkbox checkbox-primary mx-auto"
          bind:checked={value}
          {disabled}
        />
      </label>
    {/if}
  {/snippet}
</FloatingLabel>
